import { schema } from "normalizr";
import FilterSchema from "./filter";

export default new schema.Array(FilterSchema);
